import React from 'react';
import { ToastContainer } from 'react-toastify';
import TransactionsPage from '../components/TransactionsPage';

const TransactionsApp = (props) => (
  <>
    <TransactionsPage {...props} />
    <ToastContainer icon={false} />
  </>
);

export default TransactionsApp;
